export type Timeframe = "thisMonth" | "12months" | "allTime";

export const resolveTopArtistsTimeframe = (
  selectedTimeframe: Exclude<Timeframe, "allTime">,
  hasThisMonthArtists: boolean,
): Timeframe => (hasThisMonthArtists ? selectedTimeframe : "allTime");
